import React from 'react'
import styles from '../styles.module.scss'

export default ({ text = 'There are currently no tests in this state' }) => (
  <div className={styles.emptyState}>
    <h1>All done!</h1>
    <h3>{text}</h3>
  </div>
)
